import { render, staticRenderFns } from "./RewardsSuccess.vue?vue&type=template&id=c6a246ec&scoped=true"
import script from "./RewardsSuccess.vue?vue&type=script&lang=ts&setup=true"
export * from "./RewardsSuccess.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./RewardsSuccess.vue?vue&type=style&index=0&id=c6a246ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a246ec",
  null
  
)

export default component.exports